import { render, staticRenderFns } from "./resume-session.vue?vue&type=template&id=0239b12d&"
import script from "./resume-session.vue?vue&type=script&lang=ts&"
export * from "./resume-session.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports